<template>
  <span>
    {{ label }}
    <humanize-time :time="time" />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { JobRun } from '@/type';
import HumanizeTime from '@/components/HumanizeTime.vue';

export default defineComponent({
  components: { HumanizeTime },
  props: {
    jobRun: {
      type: Object as () => JobRun,
      required: true,
    },
  },
  computed: {
    label(): string|null {
      if (this.jobRun.status === 'RUNNING') return 'Started';
      if (this.jobRun.status === 'SUCCESS') return 'Finished';
      if (this.jobRun.status === 'FAILURE') return 'Failed';
      return null;
    },
    time(): string {
      if (this.jobRun.finishedAt) return this.jobRun.finishedAt;
      return this.jobRun.startedAt;
    },
  },
});
</script>
